import React from 'react';
const Accordion = ({ title, content, isActive, toggleAccordion } : any) => {
    return (
        <div className="accordion-item">
            <button
                type="button"
                className="accordion-title"
                onClick={toggleAccordion}
            >
                <div>{title}</div>
                <div>{isActive ? '-' : '+'}</div>
            </button>
        </div>
    );
};

export default Accordion;